import React, { FC } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";

import styles from "./cardHeaderStyle";

interface IProps {
  className: string;
  color: "warning" | "success" | "danger" | "info" | "primary" | "rose";
  stats: boolean;
  icon: boolean;
}

// @ts-ignore
const useStyles = makeStyles(styles);

export const CardHeader: FC<IProps> = props => {
  const classes = useStyles();
  const { className, children, color, stats, icon, ...rest } = props;
  const cardHeaderClasses = classNames({
    [classes.cardHeader]: true,
    // @ts-ignore
    [classes[color + "CardHeader"]]: color,
    [classes.cardHeaderStats]: stats,
    [classes.cardHeaderIcon]: icon,
    [className]: className !== undefined
  });
  return (
    <div className={cardHeaderClasses} {...rest}>
      {children}
    </div>
  );
};
